module.exports = __webpack_public_path__ + "img/idea-score.d10368c2.svg";